import React from 'react'
import { TitleProps } from '../../../types/components/title'
import { TitleStyle } from './style'

export const Title: TitleProps = ({ text }) => {
  return <TitleStyle>{text}</TitleStyle>
}
